import React from 'react';
import { motion } from 'framer-motion';
export function AuthoritySection() {
  return <section className="py-16 md:py-24 px-5 md:px-8" data-id="element-28">
      <div className="max-w-3xl mx-auto text-center" data-id="element-29">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-30">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-8 leading-tight" data-id="element-31">
            El problema no siempre es el sonido. Muchas veces es la atención
            atrapada en el sonido.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-gray-300 text-lg leading-relaxed text-left" data-id="element-32">
          <p data-id="element-33">Esta es la idea central del Protocolo Silencio TTPM™.</p>
          <p data-id="element-34">
            Tu cerebro tiene una capacidad llamada habituación. Es el mismo
            mecanismo que te permite dejar de notar el sonido del aire
            acondicionado, el roce de la ropa o un reloj en la pared.
          </p>
          <p data-id="element-35">
            Al principio lo percibes. Después, tu sistema nervioso lo clasifica
            como ‘no importante’. Y deja de empujarlo al centro de tu atención.
          </p>

          <div className="bg-[#15203B] p-6 md:p-8 rounded-xl border border-[#2a3150] shadow-lg my-8" data-id="element-36">
            <p className="text-[#F6C65B] font-bold text-xl mb-2" data-id="element-37">
              El problema aparece cuando el zumbido se asocia con estrés, miedo
              o frustración.
            </p>
            <p className="text-white" data-id="element-38">
              Entonces el cerebro lo marca como una amenaza. Y lo mantiene
              encendido en primer plano.
            </p>
          </div>

          <p data-id="element-39">
            El Protocolo Silencio TTPM™ fue diseñado para ayudar a romper ese
            ciclo nocturno. No peleando contra el sonido. Sino entrenando a tu
            atención para dejar de alimentarlo.
          </p>
        </motion.div>
      </div>
    </section>;
}